
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.272 1h17.456C21.988 1 23 2.044 23 3.32v1.702a2.34 2.34 0 01-.672 1.648l-7.443 7.547v5.714c0 .26-.131.5-.344.64l-.096.055-4.888 2.3a.767.767 0 01-1.094-.694v-8.033L1.606 6.64a2.342 2.342 0 01-.598-1.384L1 5.06V3.32C1 2.044 2.011 1 3.272 1zm17.456 1.535H3.272c-.402 0-.737.346-.737.785v1.74c0 .206.075.401.207.547l7.057 7.78a.768.768 0 01.199.516v7.118l3.352-1.577v-5.54c0-.162.051-.318.144-.448l.077-.092 7.666-7.773a.807.807 0 00.228-.57v-1.7c0-.44-.335-.786-.737-.786z","fill":"#224CA4"}})])
          )
        }
      }
    